import type { ReactNode } from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, CircularProgress, IconButton, Stack, Tooltip, Typography } from '@mui/material'

export type ClimateSectionTitleProps = {
  title: string
  subtitle?: string
  helpText?: ReactNode
  loading?: boolean
}

const ClimateSectionTitle = ({ title, subtitle, helpText, loading = false }: ClimateSectionTitleProps) => {
  return (
    <Stack spacing={0.25}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="subtitle1" fontWeight={800}>
          {title}
        </Typography>
        {loading && (
          <CircularProgress
            size={14}
            thickness={6}
            aria-label={`${title} loading`}
            sx={{ color: 'text.secondary', flexShrink: 0 }}
          />
        )}
        {helpText && (
          <Tooltip title={helpText} arrow enterTouchDelay={0}>
            <IconButton
              size="small"
              aria-label={`${title} help`}
              sx={{
                p: 0.25,
                color: 'text.secondary',
                '&:hover': {
                  color: 'text.primary',
                },
              }}>
              <InfoOutlinedIcon sx={{ fontSize: 15 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Stack>
  )
}

export default ClimateSectionTitle
